import React from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { Calendar, ArrowLeft } from "lucide-react";
import { blogPosts } from "../data/mock";
import { stripDiacritics } from "../lib/utils";
import usePageMetadata from "../hooks/usePageMetadata";

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((item) => item.slug === slug);

  const metadataTitle = post ? `${post.title} | Blog TOLSOL` : "TOLSOL | Blog";
  const metadataDescription = post ? stripDiacritics(post.excerpt || "") : "Art\u00edculos y novedades sobre protecci\u00f3n solar.";

  usePageMetadata({
    title: metadataTitle,
    description: metadataDescription,
  });

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <main className="pt-32 pb-24 bg-[#F2F2F2] min-h-screen">
      <article className="container mx-auto px-4 max-w-4xl">
        <Link to="/blog" className="inline-flex items-center gap-2 text-[#0A192F] hover:text-[#FFD700] font-semibold mb-8">
          <ArrowLeft className="w-4 h-4" />
          Volver al blog
        </Link>

        <header className="mb-10">
          <p className="uppercase tracking-[0.3em] text-xs text-[#0A192F]/60 mb-3">Blog Tolsol</p>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0A192F] mb-4">{post.title}</h1>
          <div className="flex items-center gap-3 text-[#0A192F]/70">
            <Calendar className="w-4 h-4 text-[#FFD700]" />
            <span>{new Date(post.date).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" })}</span>
          </div>
        </header>

        <figure className="rounded-xl overflow-hidden mb-10" style={{ aspectRatio: "16 / 9" }}>
          <img src={post.image} alt={stripDiacritics(post.title)} className="w-full h-full object-cover" />
        </figure>

        <section className="space-y-6 text-lg leading-relaxed text-[#0A192F]/80">
          {post.content?.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </section>
      </article>
    </main>
  );
};

export default BlogPost;
